import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MediaQuery from "react-responsive";
import { useNavigate } from "react-router";
import { LuFuel } from "react-icons/lu";

// COMPONENTS
import Icon from "components/Atoms/Icons/Icon";
import FuelCreditSummary from "components/Summary/FuelCreditSummary";

// DS
import {
  VertContainer,
  Col,
  VertTypography,
  VertInput,
  VertSelect,
  Form,
  VertAlert, Row,
} from "@vertem-core/vertice-ds";

// STYLES
import "Assets/styles/default/pages/fuelCredit/FuelCreditStyles.less";
import "Assets/styles/default/pages/fuelCredit/FuelCreditBanner.less";
import "Assets/styles/default/components/Forms/FormsStyles.less";

import PipeProvider from "Services/Providers/PipeProvider";
import usePipeContext from "Services/Providers/PipeProvider/usePipeContext";

import { pointsMask } from "Utils/commons/points";
import generateUUID from "Utils/generateUUID";
import ModalTermOfUse from "components/Modal/ModalTermOfUse";
import CheckoutModal from "components/2FA/CheckoutModal2FA/CheckoutModal";
import CheckoutProvider, { useCheckoutProvider } from "components/Checkout/CheckoutProvider";
import { REDEMPTION_FUEL_CREDIT_RESET } from "redux/Reducers/FuelCredit/FuelCreditReducer";
import { MILEAGE_TOKEN_TYPE } from "../../components/2FA/CheckoutModal2FA/CheckoutModal/Provider";
import OnboardingRedirectModal from 'components/Onboarding/OnboardingRedirectModal';

const initState = {
  title: "",
  description: "",
  image: "",
  status: "",
  milesQuantity: 0,
  clientProductCode: 0,
  pointsAdjustment: 0,
  partnerCampaignPackageId: 0,
  partnerId: 0,
  partner: null,
  pointsQuantity: 0,
  partnerCampaignPackages: [],
  id: 0,
  insertDate: "",
};

const FuelBanner = () => {
  return (
    <VertContainer>
      <MediaQuery maxWidth={768}>
        <div className="fuel-banner fuel-banner-mobile">
          <img src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Services/banner-credito-combustivel-min.png" />
        </div>
      </MediaQuery>
      <MediaQuery minWidth={769}>
        <div className="fuel-banner fuel-banner-desktop">
          <img src="https://vertice-ds.s3.amazonaws.com/Assets/Images/Services/banner-credito-combustivel-min.png" />
        </div>
      </MediaQuery>
    </VertContainer>
  );
};

const Alert2FAFailed = () => {
  const { errors } = useCheckoutProvider();
  if (!errors['fuelCredit2FACancel']) return null
  return (<>
    <VertAlert
      type='error'
      className='toast-alert'
      message={errors['fuelCredit2FACancel'].title}
      description={errors['fuelCredit2FACancel'].message}
      closable={false}
    />
  </>)
}

// Fuel Credit
const FuelCreditComponent = () => {
  const { callApi } = usePipeContext();
  const navigate = useNavigate();
  const Dispatch = useDispatch()
  const Participants = useSelector(({ Participants: data }) => data);
  const FuelCredit = useSelector(({ FuelCredit: data }) => data);
  const Catalog = useSelector(({ Catalog: data }) => data);
  const Balance = useSelector(({ Balance: data }) => data);
  const userProfile = useSelector((state) => state?.oidc.user.profile);

  const [packageSelected, setSelectPackage] = useState({ ...initState });
  const [hasValid, setHasValid] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [hasErrorFuelCredit, setHasErrorFuelCredit] = useState(false);
  const [packageListOptions, setPackageListOptions] = useState([]);
  const [customAliasUUID, setCustomAliasUUID] = useState(generateUUID());
  const [openModalTerms, setOpenModalTerms] = useState(false);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);

  const { errors } = useCheckoutProvider();

  const modalHandle = () => {
    setOpenModalTerms(!openModalTerms);
  };

  const [useForm] = Form.useForm();
  const shellSupplierId = 117;
  const clientId = userProfile["custom:client_id"];
  const { pointsValue } = Balance;
  const {
    currencyConfiguration: { decimalPlaces, pointsName },
  } = Catalog;

  const fetchData = (symbol, payload = null) => {
    const alias = generateUUID();
    callApi({
      symbol,
      alias,
      payload,
    });
  };

  const hasError = () => {
    if (FuelCredit?.isError && FuelCredit?.error) {
      setHasErrorFuelCredit(true);
      return true;
    }

    setHasErrorFuelCredit(false);
    return false;
  };

  const redemptionFuelCredit = () => {
    const orderFuelCredit = {
      totalMiles: packageSelected.milesQuantity,
      totalPoints: packageSelected.pointsQuantity,
      transferKey: "cpf",
      loyaltyNumber: Participants.partnerCpf.value,
      cpf: Participants.partnerCpf.value,
      participantName: Participants.name.value,
      offline: false,
      orderItems: [
        {
          quantity: 1,
          points: packageSelected.pointsQuantity,
          miles: packageSelected.milesQuantity,
          totalPoints: packageSelected.pointsQuantity,
          packageName: packageSelected.title,
          clientProductCode: packageSelected.clientProductCode,
          pointsAdjustment: packageSelected.pointsAdjustment,
          partnerCampaignPackageId: packageSelected.partnerCampaignPackageId,
        },
      ],
      orderTypeId: 1,
    };

    fetchData("REDEMPTION_FUEL_CREDIT", {
      supplierId: shellSupplierId,
      order: orderFuelCredit,
    });
  };

  const formatPackageValue = () => {
    if (!FuelCredit?.isError) {
      const list = FuelCredit?.package.map((item) => {
        return {
          label: item.title || "",
          value: item.id,
        };
      });
      setPackageListOptions(list);
    }
  };


  const handlePackageSelected = (value) => {
    const pack = FuelCredit?.package.find((item) => item.id === value);
    const valid = pack && pointsValue >= pack.pointsQuantity;
    const pointsFormated = pointsMask(
      pack?.pointsQuantity,
      decimalPlaces,
      pointsName
    );

    useForm.setFields([
      {
        name: "pointsUsed",
        value: `${pointsFormated.value} ${pointsFormated.label}`,
        errors: !valid ? ["Saldo de pontos insuficiente para pagamento."] : [],
      },
    ]);

    setHasValid(valid);
    setSelectPackage(pack);
  };

  useEffect(() => {
    hasError();
  }, [FuelCredit?.isError]);

  useEffect(() => {
    if (FuelCredit?.finishRequests) formatPackageValue();
  }, [FuelCredit?.finishRequests]);

  useEffect(() => {
    if (
      FuelCredit?.sendSuccess &&
      !FuelCredit?.isError &&
      FuelCredit.status !== 406 &&
      FuelCredit.status !== "RequiresTokenValidation"
    ) {
      navigate(
        `/order-details?orderId=${FuelCredit?.order?.liveOrderId}&fromCheckout=true`
      );
    }
  }, [FuelCredit?.sendRedemption]);

  useEffect(() => {
    if (errors && errors['fuelCredit2FACancel'] && FuelCredit && FuelCredit?.error) {
      Dispatch({ type: REDEMPTION_FUEL_CREDIT_RESET })
    }
  }, [errors, FuelCredit, Dispatch]);

  const onboardingRequired = (
    FuelCredit?.statusCode === 406 ||
    FuelCredit?.error?.statusCode === 406 ||
    FuelCredit?.error?.status === 'OnBoardingRequired'
  );

  useEffect(() => {
    if (FuelCredit?.error?.status == 'OnBoardingRequired') setShowOnboardingModal(true);
  }, [FuelCredit?.error]);

  return (
    <PipeProvider
      apiSymbols={[
        {
          symbol: "FETCH_PACKAGES_BY_SUPPLIERID",
          alias: customAliasUUID,
          payload: {
            supplierId: shellSupplierId,
            clientId: clientId,
          },
        },
      ]}
    >
      {(() => {
        if (!FuelCredit?.error) return null
        return (
          <CheckoutModal
            propsStatus={(
              FuelCredit?.error &&
              FuelCredit?.error?.description === "AuthenticationRequired"
            ) ? 'RequiresTokenValidation' : null}
            propsServiceName={'FUELCREDIT'}
            purchaseData={
              (FuelCredit?.error &&
                FuelCredit?.error?.orderMileageId) ? ({
                  mileageId: FuelCredit?.error?.orderMileageId,
                  supplierId: shellSupplierId
                }) : null
            }
            typeToken={MILEAGE_TOKEN_TYPE}
            propsOrderId={(
              FuelCredit?.error &&
              FuelCredit?.error?.orderId
            ) ? FuelCredit?.error?.orderId : null}
          />
        )
      })()}
      <FuelBanner />
      <VertContainer className="fuelCredit-page-wrapper">
        <Alert2FAFailed />
        {(() => {
          if (hasErrorFuelCredit && FuelCredit?.error && (FuelCredit?.error?.description !== "AuthenticationRequired" && FuelCredit?.error?.message !== "2FA Required" && FuelCredit?.error?.message !== "OnBoardingRequired" && FuelCredit?.error !== "OnBoardingRequired")) return (<Col className='margin-bottom-extra-small'>
            <VertAlert
              className={`toast-alert`}
              message={(typeof FuelCredit?.error === 'string') ? FuelCredit?.error : FuelCredit?.error?.message}
              description={"Por favor tente novamente em instantes"}
              size="small"
              type="error"
            />
          </Col>)
          return null
        })()}
        {(() => {
          if (onboardingRequired)
            return (
              <OnboardingRedirectModal 
                open={showOnboardingModal}
                handleClose={() => setShowOnboardingModal(false)}
              />
            );
          return null
        })()}
        <Col className="fuelCredit-page">
          <Col className="fuelCredit-page-container">
            <Col className="fuelCredit-page-content">
              <Col className="fuelCredit-page-title">
                <Icon
                  className="lucide color-neutral-dark-darker"
                  size="24px"
                  component={LuFuel}
                />
                <VertTypography.Title level={2}>
                  Crédito combustível Shell Box
                </VertTypography.Title>
              </Col>
              <VertTypography.Text>
                Abasteça o seu veículo com pontos. Selecione o valor do
                crédito que deseja:
              </VertTypography.Text>
              <Col className="forms-method-payment-wrapper w-100">
                <Form
                  name="FormsRechargePhone"
                  form={useForm}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  initialValues={{ remember: true }}
                  autoComplete="off"
                  layout="vertical"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "var(--spacing-regular)",
                  }}
                >
                  <div className="formItem">
                    <Form.Item>
                      <VertSelect
                        value={packageSelected.id}
                        key={"packageListOptions"}
                        items={packageListOptions}
                        placeholder="Selecionar Crédito"
                        onChange={(value) => handlePackageSelected(value)}
                        showSearch
                      />
                    </Form.Item>
                    <Form.Item name="pointsUsed">
                      <VertInput
                        className="readonly"
                        label="Pontos utilizados"
                      />
                    </Form.Item>
                  </div>
                </Form>
              </Col>
            </Col>
            <Col className="fuelCredit-page-summary">
              <FuelCreditSummary
                {...packageSelected}
                finish={redemptionFuelCredit}
                acceptTerms={acceptTerms}
                isValid={hasValid && acceptTerms}
                termsChange={(value) => {
                  setAcceptTerms(value);
                }}
                openTerms={modalHandle}
              />
            </Col>
            {openModalTerms && (
              <ModalTermOfUse
                title={"Termos do Regulamento de Shell Box"}
                open={openModalTerms}
                acceptTerms={() => {
                  setAcceptTerms(true), modalHandle();
                }}
                terms={{
                  vendorId: shellSupplierId,
                  type: "Vendor",
                }}
                onStateModal={modalHandle}
              />
            )}
          </Col>
        </Col>
      </VertContainer>
    </PipeProvider>
  );
};

export default (props) => (
  <CheckoutProvider>
    <FuelCreditComponent {...props} />
  </CheckoutProvider>
);
